declare const open_db: (db_name: string, list: { url: string; kind?: string }[] | undefined) => Promise<IDBDatabase | void>;
declare const self: { db_version: { [key: string]: number } };

// 寫入 indexedDB
export default function set_db(db_name: string, list: { url: string; kind?: string }[] | undefined, value: any): Promise<void> {
  return new Promise((resolve) => {
    !self.db_version[db_name] && (self.db_version[db_name] = 1);
    open_db(db_name, list).then((db: void | IDBDatabase): void | PromiseLike<void> => {
      if (db) {
        if (list) {
          const set = () => {
            Promise.all(list.map((item): Promise<unknown> => readwrite(db, item.url)))
              .catch(() => {})
              .finally(() => {
                db.close();
                setTimeout(() => {
                  resolve();
                }, 0);
              });
          };
          set();
        }
      }
    });
  });
  function readwrite(db: IDBDatabase, object_store_name: string) {
    return new Promise((resolve, reject) => {
      try {
        const tx: IDBTransaction = db.transaction(object_store_name, "readwrite");
        const store: IDBObjectStore = tx.objectStore(object_store_name);
        const DBRequest: IDBRequest<IDBValidKey> = store.put(value[object_store_name] || value, 0);
        DBRequest.onsuccess = (): void => {
          resolve(undefined);
        };
        // DBRequest.onerror = (): void => {
        //     console.error('Error writing database ' + db_name + '.');
        // }
      } catch (err) {
        console.error("set", object_store_name, err);
        db.close();
        setTimeout(() => {
          self.db_version[db_name] += 1;
          set_db(db_name, list, value).finally(() => {
            resolve(undefined);
          });
        }, 0);
      }
    });
  }
}
